import { useState } from "react";
import { FaMoon } from "react-icons/fa";
import SwitchRow from "../shared/SwitchRow";

export default function DarkmodeSettingsRow() {
  const [darkmodeActive, setNotificationsActive] = useState(false);

  return (
    <SwitchRow
      disabled={true}
      title={"Darkmode"}
      icon={<FaMoon size={20} className="mr-2 text-red-700" />}
      isActive={darkmodeActive}
      onChange={() => {
        setNotificationsActive(!darkmodeActive);
      }}
    >
      <span className="text-slate-500 text-sm">
        {
          "Coming soon: Working late at night or just prefer darker colors? Turn on darkmode to give your eyes a break."
        }
      </span>
    </SwitchRow>
  );
}
